module.exports = __webpack_public_path__ + "images/emoji/black_large_square.10f6901bd6054d537085.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/black_large_square.png
// module id = xdeW
// module chunks = 14